import React, { useMemo } from 'react';
import LeaderboardChart from './LeaderboardChart';
import LeaderboardTable from './LeaderboardTable';

export default function Leaderboard({ results }) {
  const completedSports = useMemo(
    () => results.sports.filter(sport => sport.completed),
    [results.sports]
  );

  const leaderboardData = useMemo(() => {
    const participantsScores = results.participants.map(({ id, name }) => ({
      id,
      name,
      points: {}, // points per sport
    }));

    completedSports.forEach(sport => {
      console.log('=== Processing Sport:', sport.name, '===');
      console.log('Rounds:', sport.rounds, 'TieBreak Rounds:', sport.tieBreakingRounds || 0);

      const pad = (arr, len) =>
        Array.from({ length: len }, (_, i) => arr?.[i] ?? 0);

      const sportScores = results.participants.map(({ id }) => {
        const entry = sport.results.find(r => r.id === id);
        const rounds = entry?.results ?? [];

        const mainRounds = pad(rounds.slice(0, sport.rounds), sport.rounds);
        const tieBreakerRounds = pad(
          rounds.slice(sport.rounds),
          sport.tieBreakingRounds || 0
        );

        const score = sport.combined
          ? mainRounds.reduce((a, b) => a + b, 0)
          : sport.ascending
          ? Math.min(...mainRounds)
          : Math.max(...mainRounds);

        console.log(
          `Player ${id}: mainRounds=${mainRounds} tieBreakers=${tieBreakerRounds} score=${score}`
        );

        return { id, score, tieBreakerRounds };
      });

      if (sport.directPoints) {
        // The entered score is awarded as points directly, no placement ranking
        sportScores.forEach(({ id, score }) => {
          const participant = participantsScores.find(p => p.id === id);
          participant.points[sport.name] = score;
          console.log(`Awarded ${score} direct points to Player ${id} in sport ${sport.name}`);
        });
        return;
      }

      // Sort by main score, then tie-breakers
      sportScores.sort((a, b) => {
        const primary = sport.ascending ? a.score - b.score : b.score - a.score;
        if (primary !== 0) return primary;

        for (let i = 0; i < (sport.tieBreakingRounds || 0); i++) {
          const av = a.tieBreakerRounds?.[i] ?? 0;
          const bv = b.tieBreakerRounds?.[i] ?? 0;
          const diff = sport.ascending ? av - bv : bv - av;
          if (diff !== 0) return diff;
        }

        return String(a.id).localeCompare(String(b.id));
      });

      console.log('Sorted scores for sport:', sport.name, sportScores);

      sportScores.forEach(({ id }, idx) => {
        const participant = participantsScores.find(p => p.id === id);
        const points = idx === 0 ? 10 : 9 - idx;
        participant.points[sport.name] = points;
        console.log(
          `Assigned ${points} points to Player ${id} in sport ${sport.name}`
        );
      });
    });

    participantsScores.forEach(p => {
      p.totalPoints = Object.values(p.points).reduce((a, b) => a + b, 0);
      console.log(
        `Total points for ${p.name} (${p.id}):`,
        p.totalPoints,
        p.points
      );
    });

    const sortedLeaderboard = participantsScores.sort(
      (a, b) => b.totalPoints - a.totalPoints
    );

    console.log('=== Final Leaderboard ===', sortedLeaderboard);

    return sortedLeaderboard;
  }, [results, completedSports]);

  return (
    <div>
      <LeaderboardChart data={leaderboardData} sports={completedSports} />
      <LeaderboardTable data={leaderboardData} sports={completedSports} />
    </div>
  );
}
